export var featuredArticlesApiRelativePath = "/helpcenter/appearance/featuredArticles";
export var createFeaturedArticlesApi = function (baseUrl, http) {
    var apiUrl = "" + baseUrl + featuredArticlesApiRelativePath;
    return {
        getFeaturedArticles: function (dto) {
            return http.get(apiUrl + "/" + dto.locale);
        },
        updateFeaturedArticles: function (dto) {
            return http.put(apiUrl + "/" + dto.locale, dto.data);
        }
    };
};
//# sourceMappingURL=index.js.map